import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import CheckboxInput from '../inputs/CheckboxInput';
import { setAction } from '../../pages/ChartEditorPage/actions/chartEditor';
import { getChartConfig } from '../../pages/ChartEditorPage/selectors/chartEditor';
import TextInput from '../inputs/TextInput';
import { registerChangeMadeAction } from '../../redux/actions/projectConfig';
import { getProjectConfig } from '../../redux/selectors/projectConfig';
import LoaderIcon from '../loader/LoaderIcon';
import { onPublish } from '../editor/PublishHelper';
import { ButtonColor, ButtonType } from 'shared/buttons/models/ButtonModels';
import PrimaryButton from 'shared/buttons/PrimaryButton';

export default (props) => {
  const dispatch = useDispatch();
  const { passwordProtected } = useSelector(getChartConfig);
  const { published, publishLoading, changeMade } = useSelector(getProjectConfig);
  const { type } = props;
  const noPublish = published && !changeMade;
  const locked = props.inEditor && !published;

  const publish = () => {
    if (noPublish) return;
    onPublish(type, dispatch);
  };

  const onPasswordChange = (e) => {
    dispatch(
      setAction({
        passwordProtected: {
          enabled: true,
          password: e.target.value
        }
      })
    );
    dispatch(registerChangeMadeAction());
  };

  const onCheckboxChange = (e) => {
    dispatch(
      setAction({
        passwordProtected: {
          enabled: e.target.checked,
          password: e.target.value ? passwordProtected.password : ''
        }
      })
    );
    dispatch(registerChangeMadeAction());
  };

  return (
    <div className="">
      <CheckboxInput
        name={'private'}
        label={
          <span title="Click the publish button to enter a password for this project">
            {' '}
            Add password on share/embed{' '}
          </span>
        }
        onChange={onCheckboxChange}
        checked={passwordProtected.enabled}
        extraClass={'pt-4'}
        tabIndex={props.active ? null : '-1'}
      />

      {passwordProtected.enabled && (
        <TextInput
          name="search"
          type="password"
          value={passwordProtected.password}
          onChange={onPasswordChange}
          placeholder={'Enter password (minimum 8 characters)'}
          disabled={!passwordProtected.enabled}
          inputClassName={'highed-field-input'}
          tabIndex={props.active ? null : '-1'}
          extraClass={'pb-0 pt-4 mb-2'}
        />
      )}
      {!locked && !changeMade && (
        <div className="pt-4">
          <PrimaryButton
            onClick={publish}
            thin={true}
            text={
              <>
                <LoaderIcon
                  icon={noPublish ? 'circle-check' : 'key'}
                  iconClass={noPublish ? '' : 'rotate-[-45deg]'}
                  loading={publishLoading}
                />
                &nbsp;{changeMade ? 'Apply' : 'Applied'}
              </>
            }
            buttonColor={noPublish ? ButtonColor.White : ButtonColor.NavyBlue}
            buttonType={ButtonType.Info}
            className="text-sm"
          />
        </div>
      )}
    </div>
  );
};
